import { render, staticRenderFns } from "./3_giftCard.vue?vue&type=template&id=7ed89f98&scoped=true&"
import script from "./3_giftCard.vue?vue&type=script&lang=js&"
export * from "./3_giftCard.vue?vue&type=script&lang=js&"
import style0 from "./3_giftCard.vue?vue&type=style&index=0&id=7ed89f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ed89f98",
  null
  
)

export default component.exports